"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPTIONS_COLLAPSED_LENGTH = void 0;
var OPTIONS_COLLAPSED_LENGTH = exports.OPTIONS_COLLAPSED_LENGTH = 3;